<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <userLeft :active="2" />
            <div class="box5">
                <div style="overflow: hidden">
                    <div class="box6" style="float: left" v-if="id">绑定手机</div>
                    <div class="box6" style="float: left" v-else>{{ xiayibu ? '验证新手机号' : '更换手机' }}</div>
                </div>

                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 2%">
                    <div v-if="chenggong">
                        <div style="overflow: hidden; margin-top: 60px">
                            <img src="../assets/wangjimima_zhengque.png" style="width: 28px; height: 28px; float: left" alt="" />
                            <div style="float: left">
                                <div class="chenggongwenzi">恭喜您，手机号修改成功！</div>
                                <div class="chenggongwenzi">请使用新号码 {{ new_tel }} 登录</div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="jiechu">
                        <div style="overflow: hidden; margin-top: 60px">
                            <img src="../assets/wangjimima_zhengque.png" style="width: 28px; height: 28px; float: left" alt="" />
                            <div style="float: left">
                                <div class="chenggongwenzi">恭喜您，手机号解绑成功！</div>
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <div v-if="!xiayibu">
                            <div style="overflow: hidden; margin-top: 2%">
                                <div class="left_txt" v-if="id">输入手机号</div>
                                <a-input v-model="new_tel" placeholder="请输入手机号码" style="float: left; margin-left: 4%; width: 320px; height: 40px" v-if="id" />
                                <div class="left_txt" v-else>当前手机号</div>
                                <div style="font-size: 14px; float: left; margin-left: 30px; margin-top: 10px">{{ username }}</div>
                            </div>
                            <!-- v-if="id" -->
                            <div class="Verification_Code_box">
                                <div class="left_txt">图形验证码</div>
                                <a-input v-model="identifyCodetel" style="float: left; margin-left: 4%; margin-right: 20px; width: 200px; height: 40px" placeholder="请输入图形验证码" type="text" />
                                <SIdentifytel :changeCode.sync="identifyCode"></SIdentifytel>
                            </div>

                            <div style="overflow: hidden; margin-top: 2%">
                                <div class="left_txt" v-if="id">输入验证码</div>
                                <div class="left_txt" v-else>验证码</div>
                                <a-input v-model="yzm" placeholder="请输入验证码" style="float: left; margin-left: 4%; width: 200px; height: 40px" />
                                <div class="yanzhengma" v-if="id" @click="get_code">发送验证码</div>
                                <div class="yanzhengma" v-else-if="yzm_code" @click="sendCode">{{ yzm_txt }}</div>
                                <div class="yanzhengma" style="background: #bfbfbf" v-else>{{ yzm_txt }}</div>
                            </div>

                            <div style="overflow: hidden">
                                <div :class="['save_but', id ? 'save_but1' : '']" style="float: left; cursor: pointer" @click="set_code" v-if="id">绑定</div>
                                <div :class="['save_but', yzm ? 'save_but1' : '']" style="float: left; cursor: pointer" @click="xiayibu1" v-else>下一步</div>
                                <div class="quxiao" @click="$router.go(-1)">取消</div>
                            </div>
                        </div>

                        <div v-else>
                            <div style="overflow: hidden; margin-top: 2%">
                                <div class="left_txt">新手机号码</div>
                                <a-input v-model="new_tel" placeholder="请输入新手机号码" style="float: left; margin-left: 4%; width: 320px; height: 40px" />
                            </div>
                            <div class="Verification_Code_box">
                                <div class="left_txt">图形验证码</div>
                                <a-input v-model="identifyCodetelText" style="float: left; margin-left: 4%; margin-right: 20px; width: 200px; height: 40px" placeholder="请输入图形验证码" type="text" />
                                <SIdentifyText :changeCode.sync="identifyCodeText"></SIdentifyText>
                            </div>
                            <div style="overflow: hidden; margin-top: 2%">
                                <div class="left_txt">验证码</div>
                                <a-input v-model="yzm1" placeholder="请输入验证码" style="float: left; margin-left: 4%; width: 200px; height: 40px" />
                                <div class="yanzhengma" v-if="yzm_code1" @click="sendCode1">{{ yzm_txt1 }}</div>
                                <div class="yanzhengma" style="background: #bfbfbf" v-else>{{ yzm_txt1 }}</div>
                            </div>
                            <div style="overflow: hidden">
                                <div :class="['save_but', yzm1 ? 'save_but1' : '']" style="float: left; cursor: pointer" @click="quedin">确定</div>
                                <div class="quxiao">取消</div>
                            </div>
                        </div>
                    </div>

                    <div style="width: 100%; height: 1px; border: 1px dashed #eeeeee; margin-top: 80px"></div>

                    <div>
                        <div class="bottom_tips"><span style="color: #2b9a34">*</span> 若该号码无法接收验证码，请联系客服 84518160-821 周一至周五 09:00-18:00（仅收市话费）</div>
                        <div class="bottom_tips">
                            <span style="color: #2b9a34">*</span>
                            验证码进可使用一次，2分钟内有效，请尽快完成修改
                        </div>
                        <div class="bottom_tips">
                            <span style="color: #2b9a34">*</span>
                            若无法接收验证码，请检查短信是否被拦截
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import SIdentifytel from './sIdentify/SIdentifytel.vue';
import SIdentifyText from './sIdentify/SIdentifytel2.vue';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot,
        SIdentifytel,
        SIdentifyText
    },
    props: ['type'],
    data() {
        return {
            username: '',
            yzm: '',
            yzm_txt: '获取验证码',
            count: 0,
            yzm_code: true,
            xiayibu: false,
            new_tel: '',
            id: '',
            yzm1: '',
            yzm_txt1: '获取验证码',
            count1: 0,
            yzm_code1: true,
            chenggong: false,
            jiechu: false,
            identifyCodetel: '', // 输入的图形验证
            identifyCode: '', // 获取的图形验证
            identifyCodeText: '',// 获取图形验证码
            identifyCodetelText:''// 输入图形验证码
        };
    },
    created() {
        this.changeCode();
    },
    methods: {
        changeCode() {},
        // 初次绑定 发送验证码
        get_code() {
            if (this.identifyCodetel == this.identifyCode) {
                this.api.get_code({ mobile: this.new_tel }).then(res => {
                    if (res.ok) {
                        this.yzm_code = false;
                        this.countdown(60);
                        this.$message.success(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                this.$message.error('请输入正确的图形验证码');
            }
        },
        //验证
        set_code() {
            if (this.identifyCodetel == this.identifyCode) {
                this.api.set_code({ verifycode: this.yzm }).then(res => {
                    if (res.ok) {
                        // 下一步
                        this.xiayibu = true;
                        this.$message.success(res.message);
                        this.$router.push('/account_security');
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                this.$message.error('请输入正确的验证码');
            }
        },
        // 获取id
        get_id() {
            if (this.$route.query.id) {
                this.id = this.$route.query.id;
            }
        },
        //
        quedin() {
           
            this.api.chang_tel_updateMobile({ newMobile: this.new_tel, verifycode: this.yzm1 }).then(res => {
                if (res.ok) {
                    this.chenggong = true;
                    this.$message.success(res.message);
                } else {
                    this.$message.error(res.message);
                }
            });
           
        },
        xiayibu1() {
            // 校验原手机验证码
            if (this.type == 'relieve') {
                this.api.unbound({ mobile: this.username, code: this.yzm }).then(res => {
                    if (res.ok) {
                        this.jiechu = true;
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                this.api.chang_tel_valid_verifycode(this.yzm).then(res => {
                    if (res.ok) {
                        // 下一步
                        this.xiayibu = true;
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        },
        // 发送验证码
        sendCode() {
            if (this.type == 'relieve') {
                // 解除绑定
                if (this.identifyCodetel == this.identifyCode) {
                    this.api.get_verifycode({ phone: this.username, random: '手机相关' }).then(res => {
                        if (res.ok) {
                            this.yzm_code = false;
                            this.countdown(60);
                            this.$message.success(res.message);
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else {
                    this.$message.error('请输入正确的图形验证码');
                }
            } else {
                // 更换手机
                if (this.identifyCodetel == this.identifyCode) {
                    this.api.chang_tel_v_code(this.username).then(res => {
                        if (res.ok) {
                            this.yzm_code = false;
                            this.countdown(60);
                            this.$message.success(res.message);
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else {
                    this.$message.error('请输入正确的图形验证码');
                }
            }
        },
        // 倒计时
        countdown(count) {
            setTimeout(() => {
                count -= 1;

                if (count) {
                    this.yzm_txt = count + 's后重新获取';
                    this.countdown(count);
                } else {
                    this.yzm_txt = '重新获取';
                    this.yzm_code = true;
                }
            }, 1000);
        },
        get_user_info() {
            this.api.user_info().then(res => {
                this.username = res.data.mobile;
            });
        },
        // 发送验证码
        sendCode1() {
             if (this.identifyCodetelText == this.identifyCodeText) {
            this.api.chang_tel_newMobile(this.new_tel).then(res => {
                if (res.ok) {
                    this.yzm_code1 = false;
                    this.countdown1(60);
                    this.$message.success(res.message);
                } else {
                    this.$message.error(res.message);
                }
            });
             } else {
                this.$message.error('请输入正确的图形验证码');
            }
        },
        // 倒计时
        countdown1(count) {
            setTimeout(() => {
                count -= 1;
                if (count) {
                    this.yzm_txt1 = count + 's后重新获取';
                    this.countdown1(count);
                } else {
                    this.yzm_txt1 = '重新获取';
                    this.yzm_code1 = true;
                }
            }, 1000);
        }
    },
    created() {
        console.log(this.type);
        this.get_user_info();
        this.get_id();
    }
};
</script>

<style scoped>
/* 随机验证码样式 */
.Verification_Code_box {
    display: flex;
    justify-content: flex-start;
    margin-top: 2%;
}
.Verification_Code_input {
    width: 200px;
    height: 48px;
    line-height: 48px;
    margin-right: 20px;
    border: 1px solid #ede9e9;
    background-color: #e8f0fe;
    margin-left: 126px;
    padding: 0px 20px;
    outline: none;
}
.bottom_tips {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-top: 10px;
    color: #999;
}

.quxiao {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    float: left;
    margin-left: 10px;
    line-height: 40px;
    margin-top: 35px;
    cursor: pointer;
}

.yanzhengma {
    width: 100px;
    height: 40px;
    background: #2b9a34;
    float: left;
    margin-left: 20px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

.save_but {
    width: 100px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
    margin-left: 14%;
    margin-top: 4%;
    color: #fff;
    background: #bfbfbf;
}

.save_but1 {
    background: #2b9a34;
    color: #ffffff;
}

.ant-upload {
    width: 210px !important;
    height: 132px !important;
}

.chang_tel {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
    float: left;
    margin-left: 10px;
    margin-top: 5px;
}

.left_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    width: 10%;
    text-align: right;
    float: left;
    margin-top: 5px;
}

.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    width: 80%;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
.chenggongwenzi {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/change_tel.vue